import {v4 as uuid} from "uuid";
import {LabelNumberTextControl, LabelTextAreaControl} from "../../controls";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {RemoveButtonControl} from "../../controls/RemoveButtonControl";
import Rete from "rete";
import {tempActionSocket} from "../../sockets";
import {SequenceComponent} from "../SequenceComponent";

export class TextSlide {

    constructor(parentComponent, textSlideAdded, textSlideRemoved) {
        this.parentComponent = parentComponent;
        this.onTextSlideAdded = textSlideAdded;
        this.onTextSlideRemoved = textSlideRemoved;
        this.isAdded = false;
    }

    addTextSlide(node, textSlideUUID = null) {
        if (textSlideUUID == null) {
            textSlideUUID = uuid();
        }

        const headerControl = new LabelTextAreaControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextSlideHeaderKey(textSlideUUID),
            node,
            false,
            "Header"
        );

        const textControl = new LabelTextAreaControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextSlideTextKey(textSlideUUID),
            node,
            false,
            "Text"
        );

        const durationControl = new LabelNumberTextControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextSlideDurationKey(textSlideUUID),
            node,
            false,
            "Duration"
        );

        const output = new Rete.Output(
            SequenceComponentHelper.getTextSlideOutputKey(textSlideUUID),
            "Action",
            tempActionSocket,
            false
        );

        const removeTextSlideControl = new RemoveButtonControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextSlideRemoveButtonKey(textSlideUUID),
            node,
            false,
            () => this.onRemoveTextSlideClick.bind(this, node, textSlideUUID, removeTextSlideControl, headerControl, textControl, durationControl, output)
        );

        node
            .addControl(removeTextSlideControl)
            .addControl(headerControl)
            .addControl(textControl)
            .addControl(durationControl)
            .addOutput(output)

        this.textSlideAdded(node, textSlideUUID);
        node.update();
    }

    textSlideAdded(node, addedTextSlideUUID) {
        node.textSlideId = addedTextSlideUUID;
        this.isAdded = true;
        this.onTextSlideAdded();
    }

    onRemoveTextSlideClick(node, textSlideUUID, removeTextSlideControl, headerControl, textControl, durationControl, outputControl) {
        this.removeTextSlide(node, textSlideUUID, removeTextSlideControl, headerControl, textControl, durationControl, outputControl)
            .then(r => {
                this.textSlideRemoved(node, textSlideUUID);
            });
    }

    async removeTextSlide(node, textSlideUUID, removeTextSlideControl, headerControl, textControl, durationControl, outputControl) {
        node.removeControl(removeTextSlideControl);
        node.removeControl(headerControl);
        node.removeControl(textControl);
        node.removeControl(durationControl);

        outputControl.connections.map(connection => this.parentComponent.editor.removeConnection(connection));
        node.removeOutput(outputControl);

        node.update();

        this.parentComponent.editor.view.updateConnections({node});

        delete node.data[SequenceComponentHelper.getTextSlideHeaderKey(textSlideUUID)];
        delete node.data[SequenceComponentHelper.getTextSlideTextKey(textSlideUUID)];
        delete node.data[SequenceComponentHelper.getTextSlideDurationKey(textSlideUUID)];
    }

    async textSlideRemoved(node, removedTextSlideUUID) {
        node.textSlideId = null;
        this.isAdded = false;
        this.onTextSlideRemoved();
    }

    handleAnswerAdded(node) {
        if (!this.isAdded) return;

        let textSlideOutputControl = null;
        node.outputs.forEach(output => {
            const outputKey = output.key.split('_');
            if (outputKey[1] === SequenceComponent.TEXT_SLIDE_CHILD_COMPONENT_KEY) {
                if (textSlideOutputControl) throw new Error("Text Slide component cannot handle multiple outputs.");
                textSlideOutputControl = output;
            }
        });

        if (textSlideOutputControl.connections.length > 0) {
            textSlideOutputControl.connections.map(connection => this.parentComponent.editor.removeConnection(connection));
            node.update();
            this.parentComponent.editor.view.updateConnections({node});
        }
    }

    handleAnswerRemoved(node) {
        if (!this.isAdded) return;
        node.update();
    }
}